<template>
    <v-main>
    <!-- <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5"> -->
            <v-card class="elevation-12 mx-auto mt-1" max-width="500" elevation="0">
              <p class="text-center red--text text-h5 mt-6">Account</p>
              <p class="ma-4 styled-font-h1 text-center">Reset your password</p>
              <Alert />
              <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation @keyup.native.enter="reset">
                    <v-text-field
                        label="Email"
                        name="login"
                        v-model="person.email"
                        prepend-icon="mdi-email"
                        type="email"
                        required
                        rounded
                        dense
                        outlined
                        :rules="emailRules"
                    />
                    <v-text-field
                        label="New password"
                        name="password"
                        v-model="person.password"
                        prepend-icon="mdi-lock"
                        type="password"
                        required
                        rounded
                        dense
                        outlined
                        :rules="passwordRules"
                    />
                    <v-text-field
                        label="Confirm new password"
                        name="confirm_password"
                        v-model="person.password_confirmation"
                        prepend-icon="mdi-lock"
                        type="password"
                        rounded
                        dense
                        outlined
                        :rules="passwordConfirmRules"
                        required
                    />
                  </v-form>
                </v-card-text>
                <v-spacer/>
                <v-card-actions>
                    <v-btn color="buttons" rounded @click="reset">Reset Password</v-btn>
                    <v-spacer/>
                    <router-link to="login">Back to Login</router-link>

                </v-card-actions>
            </v-card>
          <!-- </v-col>
        </v-row>
      </v-container> -->
    </v-main>
</template>

<script>
import Alert from "../templates/Alert"
import { mapGetters } from 'vuex'
export default {
    name: "reset_password",
    data: () => ({
      valid: true,
      email: null,
      hasError: false,
      validToken: true,
      token: "",
      person: {
        email: "",
        password: "",
        password_confirmation: ""
      },
      passwordConfirmRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 8) || "Name must be greater than 7 characters",
        //v => (!!v && v === this.person["password"]) || "Passwords do not match"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 8) || "Name must be greater than 7 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]

    }),
    methods: {
      reset() {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('userauth/aResetPassword', { user:this.person, token: this.token})
          .then(response => {
            if (response) {
              this.$router.push({name: "Login"})
            }
          })
        }
        
      }
    },
    created() {
      this.token = this.$route.params.code;
      this.$store.dispatch('userauth/aCheckResetToken', {token: this.token})
      .then(response => {
        if(!response) {
          this.$router.push({name: 'Forgot_password'})
        }
      })
    }, 
    computed: {
      ...mapGetters(["getMessage"])
    },
    components: {
      Alert
    }
}
</script>

<style>

</style>